import React, { useEffect, useMemo, useState, useRef } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import * as Yup from "yup";
import TableContainer from '../../../components/Common/TableContainer';
import { ToastContainer,toast } from "react-toastify";
import Spinners from "../../../components/Common/Spinner";
import { useFormik } from "formik";
import DeleteModal from "../../../components/Common/DeleteModal";
import { getLoggedInUser, getRefreshToken } from "../../../helpers/fakebackend_helper"
import * as constants from "../../../constants/layout"
import { Button, Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, FormGroup, Badge } from "reactstrap";
import "../../../assets/scss/tabledesign.scss";
import "../../../assets/scss/common.scss";
import * as API_MASTER from '../../../../src/api/masterapi'
import axios from 'axios'
const ItemGroup = () => {
  document.title = "Masters | Item Group";
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [inputFocus, setInputFocus] = useState(false);
  const inputRef = useRef(null);
  const [itemgroup, setItemGroup] = useState(null);
  const [submitbtn, setSubmitbtn] = useState('');
  const [deleteTrigger, setDeleteTrigger] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [canCreate, setCanCreate] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [itemgrouplist, setitemgrouplist] = useState(null);
  const user = getLoggedInUser();
  const logoutUser = async()=>{
    localStorage.removeItem('userDetails');
    setTimeout(() => navigate('/'), 700);
  };
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      itemgroupname: (itemgroup && itemgroup.itemgroupname) || '',
      prgid:(itemgroup && itemgroup.prgid) || 0
    },
    validationSchema: Yup.object({
      itemgroupname: Yup.string().required("Please enter item group")
    }),
    onSubmit: (values) => {
      setLoading(true);
      const addItemGroup = {
        user_id: Number(user.uid),
        itemgroupname: values.itemgroupname,
        process_type: isEdit ? 'update' : 'save',
        prgid:Number(values.prgid)
      };
       disableButton();
       udfnSaveItemGroup(addItemGroup); 
    },
  });
  const udfnSaveItemGroup = async (values) => { 
		setLoading(true);
		const user = getLoggedInUser();
    var apiUrl='';
		var uploadData = {};
		if (isEdit === true) {
			uploadData = {
				user_id: values.user_id,
				prgid:  Number(values.prgid),
				prg_name: values.itemgroupname.trim(),
        loginfrom:10
			};
			apiUrl =  API_MASTER.MASTER_API.ITEMGROUP_MASTER_UPDATE;
		} else {
			uploadData = {
				user_id: values.user_id,
				prgid:  0,
				prg_name: values.itemgroupname.trim(),
        loginfrom:10
			};
			apiUrl =  API_MASTER.MASTER_API.ITEMGROUP_MASTER_SAVE;
		}
		const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
    const response = await axios.post(process.env.REACT_APP_BASE_URL +apiUrl , uploadData,config);
    try {
      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
          const refresh = await getRefreshToken();
          if (refresh) {
              if (Number(refresh) === constants.invalidRefreshToken) {
                  logoutUser();
              } else {
                  await udfnSaveItemGroup(values);
              }
          }
      }    
      if (response && response?.data?.body?.status == '200' || response && response?.data?.body?.status == 200) {
        if (isEdit === true) {
          setModal(false);   
        }
        else{          
          if (submitbtn !== 'savecontinue') {
            setModal(false);      
          }
        }
        enableButton();
        udfnClear();
        toast.success(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
        getItemGroupList();
      } else {
        enableButton();
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
		} catch (error) {
      enableButton();
			setLoading(false);
      toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
		}
	}; 
  const udfnDeleteItemGroup = async (values) => { 
		setLoading(true);
		const user = getLoggedInUser();
    var apiUrl =  API_MASTER.MASTER_API.ITEMGROUP_MASTER_DELETE;
		var uploadData = {
      user_id:values.user_id,
      prgid:values.prgid,
      loginfrom:10
		}
		const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
    const response = await axios.post(process.env.REACT_APP_BASE_URL +apiUrl , uploadData,config);
    try {
      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
          const refresh = await getRefreshToken();
          if (refresh) {
              if (Number(refresh) === constants.invalidRefreshToken) {
                  logoutUser();
              } else {
                  await udfnDeleteItemGroup(values);
              }
          }
      }    
      if (response && response?.data?.body?.status == '200' || response && response?.data?.body?.status == 200) {       
        setLoading(false);
        toast.success(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
        getItemGroupList();
      } else {
        setLoading(false);
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
		} catch (error) {
			setLoading(false);
      toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
		}
	};
  const disableButton = () => {
    setButtonDisabled(true);
  };
  const enableButton = () => {
    setButtonDisabled(false);
  };
useEffect(()=> {
  setCanCreate(true)
},[])
const udfnClear = ()=>{
  setItemGroup(''); 
  enableButton()
  validation.resetForm();
  setIsEdit(false);
  inputRef.current.focus();
}
const getItemGroupList = async () => {
  setLoading(true);
 const data = { user_id: Number(user.uid),
  loginfrom:10 };
const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
 try {
     const response = await axios.post(process.env.REACT_APP_BASE_URL +API_MASTER.MASTER_API.ITEMGROUP_MASTER_LIST , data,config);
     if (response && response.statusFlag === 3) {
         toast.error(response.message, { autoClose: 2000 });
         localStorage.removeItem("authUser");
         window.location.reload();
         return;
     }
     if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
         const refresh = await getRefreshToken();
         if (refresh) {
             if (Number(refresh) === constants.invalidRefreshToken) {
                 logoutUser();
             } else {
                 await getItemGroupList();
             }
         }
     }
     if (response?.data?.body?.itemgrouplist) {
       setitemgrouplist(response.data.body.itemgrouplist);
       setLoading(false);
     } else {
         toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
         setLoading(false);
     }
 } catch (error) {
     // Handle error
     console.error("Item Group List API Error:", error);
 }
}
  const columns = useMemo(
    () => [
      {
        header: 'Actions',
        id:'Action',
        width: '8%',
        cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <div
                    to="#"
                    className="btn btn-sm btn-soft-info"
                    onClick={() => {
                      const itemgroupdata = cellProps.row.original;
                      onEditClick(itemgroupdata);
                    }}
                  >
                    <i className="mdi mdi-pencil-outline" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </div>
                  <div  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={() => {
                    const itemgroupdata = cellProps.row.original; onClickDelete(itemgroupdata);
                  }}
                  >
                    <i className="mdi mdi-delete-outline" id="deletetooltip" />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </div>
            </div>
          );
        }
      },
      {
        header: 'S.No.',
       // accessorKey: 'sno',
        width: '8%',
        enableColumnFilter: false,
        className: 'pl-25',
        cell: ({ row, table }) =>
          <div className="text-center">{
            (table.getSortedRowModel()?.flatRows?.findIndex((flatRow) => flatRow.id === row.id) || 0) + 1
          }
          </div>
      },
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
            Item Group ▼
          </span>
        ),
        id:'group Action',
        accessorKey: 'itemgroupname',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
            No.of Items ▼
          </span>
        ),
        accessorKey: 'totalitems',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          return (
            <div className="text-center">
                  {cellProps?.row?.original?.totalitems}
            </div>
          );
        }
      },
      // {
      //   header: (
      //     <span style={{ cursor: 'pointer' }}>
      //       Created By ▼
      //     </span>
      //   ),

      //   id:'created Action',
      //   accessorKey: 'itemgroup_created',
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: (cellProps) => {
      //     return (
      //       <div className="created">
      //             {cellProps?.row?.original?.itemgroup_created}<br/>
      //             {cellProps?.row?.original?.itemgroup_createdon}
      //       </div>
      //     );
      //   }
      // },
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
          Last Updated
        </span>
        ),        
        id:'update Action',
        accessorKey: 'itemgroup_updated',
        // enableColumnFilter: false,
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          const updatedby = cellProps?.row?.original?.itemgroup_updated;
          return (
            <div className="created">
            {updatedby === "" || updatedby === "-" ? (
              <div>{cellProps?.row?.original?.itemgroup_created}<br/>
                 {cellProps?.row?.original?.itemgroup_createdon}</div>
            ) : (
                 <div>{cellProps?.row?.original?.itemgroup_updated}<br/>
                 {cellProps?.row?.original?.itemgroup_updatedon}</div>
               )}
               </div>
          );
        }
      }
    ],
    []
  );
  const onClickDelete = (boardData) => {
    setItemGroup(boardData);
    setDeleteModal(true);
  };
  const handleAddClick = () => {
    enableButton()
    validation.resetForm();
    setIsEdit(false);
    setItemGroup('');
    toggle();
  };
  const toggle = () => {
    setModal(prev => !prev);
  };
  useEffect(() => {
    if (modal && inputRef.current && inputFocus) {
      inputRef.current.focus();
      setInputFocus(false);
    }
  }, [modal, inputFocus]);
  useEffect(() => {
    if (modal) {
      setInputFocus(true);
    }
  }, [modal]);
  const onEditClick = (itemgroupdata) => {
    enableButton()
    validation.resetForm();
    setItemGroup(itemgroupdata);
    toggle();
    setIsEdit(true);
    validation.setValues({ 
      itemgroupname: itemgroupdata.itemgroupname,
      prgid:itemgroupdata.prgid,
    });
    setLoading(false);
  }
  const handleDeleteOrder = () => {
    setDeleteTrigger(true);
    setLoading(true);
    const deleteGroup = {
      user_id: Number(user.uid),
      prgid:Number(itemgroup.prgid)
    };
    udfnDeleteItemGroup(deleteGroup);
    setDeleteModal(false);
  };
  useEffect(() => {
    getItemGroupList()
    document.getElementById('headerTitle').innerHTML = 'Item Group';
  }, []);
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content" style={{ height: '100%' }}>
        <div className="container-fluid">
          {/* <Breadcrumbs title="Masters" breadcrumbItem="Exam Board" /> */}
          <Row>
            {isLoading ?
              <Spinners setLoading={setLoading} />
              :
              <Col xs="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={itemgrouplist || []}
                      isGlobalFilter={true}
                      isPagination={true}
                      isAddButton={canCreate}
                      buttonName="Add"
                      SearchPlaceholder="Search..."
                      pagination="pagination"
                      handleUserClick={handleAddClick}
                     // isCustomPageSize={true}
                      buttonClass="btn btn-primary waves-effect waves-light mb-2 me-2 addOrder-modal"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            }
          </Row>
          <Modal isOpen={modal} toggle={toggle} backdrop="static">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Item Group" : "Add Item Group"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label>Item Group<span style={{ color: 'red' }}>*</span></Label>
                      <Input
                        name="itemgroupname"
                        type="text"
                            autoComplete="off"
                        placeholder="Item Group"
                        validate={{ required: { value: true } }}
                        maxLength={constants.textboxLength.itemgroup_name}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.itemgroupname || ""}
                        invalid={validation.touched.itemgroupname && validation.errors.itemgroupname}
                        innerRef={inputRef}

                      />
                      {validation.touched.itemgroupname && validation.errors.itemgroupname ? (
                        <FormFeedback type="invalid">{validation.errors.itemgroupname}</FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button
                        color="success"
                        type="submit"
                        className="save-user"
                        onClick={() => setSubmitbtn('savebtn')}
                        disabled={isButtonDisabled}

                      >
                        {!!isEdit ? "Update" : "Save"}
                      </Button>
                      {!isEdit && (
                        <Button
                          color="primary"
                          type="submit"
                          className="save-and-continue-user"
                          onClick={() => setSubmitbtn('savecontinue')}
                          style={{ marginLeft: '10px' }}
                          disabled={isButtonDisabled}>
                          Save & Continue
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </React.Fragment>
  );
}

export default ItemGroup;